import React from 'react';

const Home = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.2724 8.20395L12.8254 1.48695C12.6487 1.3461 12.4294 1.26941 12.2034 1.26941C11.9774 1.26941 11.7581 1.3461 11.5814 1.48695L3.13342 8.20395C2.89797 8.39123 2.7078 8.62921 2.57708 8.90017C2.44636 9.17114 2.37845 9.4681 2.37842 9.76895V19.1869C2.37842 19.8235 2.63127 20.4339 3.08136 20.884C3.53145 21.3341 4.1419 21.5869 4.77842 21.5869H10.2034V16.8349C10.2034 16.5697 10.3088 16.3154 10.4963 16.1278C10.6838 15.9403 10.9382 15.8349 11.2034 15.8349H13.2034C13.4686 15.8349 13.723 15.9403 13.9105 16.1278C14.0981 16.3154 14.2034 16.5697 14.2034 16.8349V21.5869H19.6274C20.2639 21.5869 20.8744 21.3341 21.3245 20.884C21.7746 20.4339 22.0274 19.8235 22.0274 19.1869V9.76995C22.0274 9.4691 21.9595 9.17214 21.8288 8.90117C21.698 8.63021 21.5079 8.39223 21.2724 8.20495"
        fill="#191F28"
      />
    </svg>
  );
};

export default Home;
